import { darken, ThemeOptions } from '@nelnet/unifi-components-react';

const colorPrimary = '#3C72C3';
const colorPrimaryDark = darken(colorPrimary, 0.2);
const colorSecondary = '#B1549B';
const colorSecondaryDark = darken(colorSecondary, 0.2);

const customPaletteThemeOptions = {
  themeName: 'Custom Palette',
  palette: {
    primary: {
      main: colorPrimary,
      dark: colorPrimaryDark,
    },
    secondary: {
      main: colorSecondary,
      dark: colorSecondaryDark,
    },
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        '&:focus': {
          backgroundColor: colorPrimaryDark,
          boxShadow: `0 0 0 4px ${darken(colorPrimaryDark, 0.4)}`,
        },
      },
      containedSecondary: {
        '&:focus': {
          backgroundColor: colorSecondaryDark,
          boxShadow: `0 0 0 4px ${darken(colorSecondaryDark, 0.4)}`,
        },
      },
    },
  },
} as ThemeOptions;

export default customPaletteThemeOptions;
